import { message } from 'antd';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import {
  IProjectDocInfo,
  IProjectDocSearch,
  IProjectData,
  IProjectDocData,
  IDocAddVisitLog,
  IProjectSearchListItem,
} from '../../model/api-modules/document';
import { API_PREFIX } from '../config';

export const getProjectDocSearch = (params: IProjectDocSearch) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      // const url = `${API_PREFIX}/website/document/proxy/api/get-project-doc-search`;
      const url = `${API_PREFIX}/doc/proxy/api/get-project-doc-search`;
      const response = await api.commonRequest('GET', url, params);
      const res = await parsedResponse<{
        doc_list: ReadonlyArray<IProjectSearchListItem>;
      }>(response, 'data');
      return res;
    } catch (err) {
      if (err instanceof APIError) {
        message.error(err.message);
      }
      return null;
    }
  });

// export const getDocSearch = () =>
//   withAPIAccount(AccountType.auto, async (api) => {
//     try {
//       const url = `${API_PREFIX}/website/document/proxy/api/get-doc-search`;
//       const response = await api.commonRequest('GET', url);
//       const res = await parsedResponse<IProjectDocSearch[]>(response, 'data');
//       return res;
//     } catch (err) {
//       if (err instanceof APIError) {
//         message.error(err.message);
//       }
//       return null;
//     }
//   });
export const getProject = (data: IProjectData) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      // const url = `${API_PREFIX}/website/document/proxy/api/get-project`;
      const url = `${API_PREFIX}/doc/proxy/api/get-project`;
      const response = await api.commonRequest('GET', url, {
        area: data.area,
        proxy_doc: data.proxy_doc,
      });
      const res = await parsedResponse<[]>(response, 'data');
      return res;
    } catch (err) {
      if (err instanceof APIError) {
        message.error(err.message);
      }
      return null;
    }
  });

export const getProjectDocInfo = (data: IProjectDocData) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      // const url = `${API_PREFIX}/website/document/proxy/api/get-project-doc-info`;
      const url = `${API_PREFIX}/doc/get-project-doc-info`;
      const body: IProjectDocData = {
        area: data.area,
        proxy_doc: data.proxy_doc,
        projectId: data.projectId,
      };
      if (data.simplified) {
        body.simplified = data.simplified;
      }
      const response = await api.commonRequest('GET', url, body);
      const res = await parsedResponse<IProjectDocInfo>(response, 'data');
      return res;
    } catch (err) {
      if (err instanceof APIError) {
        message.error(err.message);
      }
      return null;
    }
  });

export const docAddVisitLog = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      // const url = `${API_PREFIX}/website/document/proxy/api/doc-add-visit-log`;
      const url = `${API_PREFIX}/doc/proxy/api/doc-add-visit-log`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IDocAddVisitLog[]>(response, 'data');
      return res;
    } catch (err) {
      if (err instanceof APIError) {
        message.error(err.message);
      }
      return null;
    }
  });

// export const uploadFile = () =>
//   withAPIAccount(AccountType.auto, async (api) => {
//     try {
//       const url = `${API_PREFIX}/document/upload_file`;
//       const response = await api.commonRequest('GET', url);
//       const res = await parsedResponse<IDocAddVisitLog[]>(response, 'data');
//       return res;
//     } catch (err) {
//       if (err instanceof APIError) {
//         message.error(err.message);
//       }
//       return null;
//     }
//   });

// export const setScore = () =>
//   withAPIAccount(AccountType.auto, async (api) => {
//     try {
//       const url = `${API_PREFIX}/document/setScore`;
//       const response = await api.commonRequest('POST', url);
//       const res = await parsedResponse<IDocAddVisitLog[]>(response, 'data');
//       return res;
//     } catch (err) {
//       if (err instanceof APIError) {
//         message.error(err.message);
//       }
//       return null;
//     }
//   });
export const postFeedback = (body: any) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/website/document/ai/feedback`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (err) {
      if (err instanceof APIError) {
        message.error(err.message);
      }
      return null;
    }
  });
